import {
  FETCH_PROFIL,
  FETCH_PROFILE_SUCCESS,
  SHOW_PROFILE_MESSAGE,
  ON_UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  SHOW_PROFILE_BUTTON_LOADER,
  ON_CHANGE_PASSWORD_PROFILE,
  SHOW_PROFILE_PASSWORD_BUTTON_LOADER,
  UPDATE_PROFILE_PASSWORD_SUCCESS,
  HIDE_PROFILE_MESSAGE
} from 'constants/ActionTypes';

export const fetchProfile = () => {
  return {
    type: FETCH_PROFIL
  };
};
export const fetchProfileSuccess = (data) => {
  return {
    type: FETCH_PROFILE_SUCCESS,
    payload: data
  }
};
export const onUpdateProfile = (data) => {
  return {
    type: ON_UPDATE_PROFILE,
    payload: data
  }
};
export const updateProfileSuccess = (data) => {
  return {
    type: UPDATE_PROFILE_SUCCESS,
    payload: data
  }
};
export const showProfileMessage = (message, messageStatus = false) => {
  return {
    type: SHOW_PROFILE_MESSAGE,
    payload: { message, messageStatus }
  };
};
export const showProfileButtonLoader = () => {
  return {
    type: SHOW_PROFILE_BUTTON_LOADER,
  };
};
export const onChangePasswordProfile = (data) => {
  return {
    type: ON_CHANGE_PASSWORD_PROFILE,
    payload: data
  };
};
export const showProfilePasswordButtonLoader = () => {
  return {
    type: SHOW_PROFILE_PASSWORD_BUTTON_LOADER,
  };
};
export const updateProfilePasswordSuccess = () => {
  return {
    type: UPDATE_PROFILE_PASSWORD_SUCCESS
  };
};
export const hideProfileMessage = () => {
  return {
    type: HIDE_PROFILE_MESSAGE
  };
};


// WEBPACK FOOTER //
// ./actions/Profile.js